"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HashingType = void 0;
var HashingType;
(function (HashingType) {
    let Type;
    (function (Type) {
        Type["md5"] = "81";
        Type["sha1"] = "82";
        Type["sha256"] = "83";
        Type["keccak256"] = "88";
        Type["keccak512"] = "89";
        Type["sha3_256"] = "90";
        Type["sha3_512"] = "91";
    })(Type = HashingType.Type || (HashingType.Type = {}));
    function hashTypeStrToType(typeStr) {
        switch (typeStr) {
            case '81': return HashingType.Type.md5;
            case '82': return HashingType.Type.sha1;
            case '83': return HashingType.Type.sha256;
            case '88': return HashingType.Type.keccak256;
            case '89': return HashingType.Type.keccak512;
            case '90': return HashingType.Type.sha3_256;
            case '91': return HashingType.Type.sha3_512;
            default: throw Error('unmatched hashing type');
        }
    }
    HashingType.hashTypeStrToType = hashTypeStrToType;
})(HashingType = exports.HashingType || (exports.HashingType = {}));
//# sourceMappingURL=HashingType.js.map